import LRU from 'lru-cache';
var defaultOpts = {
  maxAge: 1000 * 60 * 60 * 6,
  // six hours
  max: 500
};

var defaultResolver = function defaultResolver() {
  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(arg).trim().toLowerCase();
}; // Memoize only success requests


export default (function (func) {
  var resolver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultResolver;
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOpts;
  var cache = new LRU(opts);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var key = resolver.apply(void 0, args);

    if (cache.has(key)) {
      return cache.get(key);
    }

    var executionPromise = Promise.resolve().then(function () {
      return func.apply(void 0, args);
    });
    executionPromise.catch(function () {
      return cache.del(key);
    });
    cache.set(key, executionPromise);
    return executionPromise;
  };
});